import React from 'react'

/**
 * Resalta las coincidencias de `query` dentro de `text`.
 * Insensible a mayúsculas y acentos. Devuelve un fragmento React seguro
 * (no usa dangerouslySetInnerHTML).
 *
 * @param {string} text  Texto a renderizar
 * @param {string} query Término buscado
 * @returns {React.ReactNode}
 */
export function highlight(text, query) {
  const value = text == null ? '' : String(text)
  const term = (query || '').trim()
  if (!term || term.length < 2) return value

  // Normaliza para comparar sin acentos
  const norm = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  const haystack = norm(value)
  const needle = norm(term)

  const parts = []
  let from = 0
  let idx = haystack.indexOf(needle, from)
  if (idx === -1) return value

  let key = 0
  while (idx !== -1) {
    if (idx > from) parts.push(value.slice(from, idx))
    parts.push(
      <mark
        key={`hl-${key++}`}
        className="rounded bg-warning/25 px-0.5 font-semibold text-ink"
      >
        {value.slice(idx, idx + needle.length)}
      </mark>
    )
    from = idx + needle.length
    idx = haystack.indexOf(needle, from)
  }
  if (from < value.length) parts.push(value.slice(from))
  return <>{parts}</>
}

export default highlight
